import { render, staticRenderFns } from "./ExpertiseCardSection.vue?vue&type=template&id=1335a71a&scoped=true&"
import script from "./ExpertiseCardSection.vue?vue&type=script&lang=js&"
export * from "./ExpertiseCardSection.vue?vue&type=script&lang=js&"
import style0 from "./ExpertiseCardSection.vue?vue&type=style&index=0&id=1335a71a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1335a71a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
